export class Rue {
  public id: string | number;
  public codePostal: string;
  public codeLangue: string;
  public codeRue: string;
  public rueNom: string;
  public isFromAnotherAPI: boolean;

  constructor(data) {
    for (const prop in data) {
      if (Object.prototype.hasOwnProperty.call(data, prop)) {
        this[prop] = data[prop];
      }
    }
  }
}
